import { Navigate } from '@tanstack/react-router';

import { authClient } from '../auth.js';
import { LoginForm } from '../components/LoginForm.jsx';
import { t } from '../i18n/es.js';
import { useSession } from '../session.jsx';

export function LoginPage() {
  const { status } = useSession();
  if (status === 'loading') return <p className="muted">{t.app.loading}</p>;
  if (status !== 'anonymous') return <Navigate to="/" />;

  return (
    <main className="page">
      <LoginForm
        onSubmit={async (email, password) => {
          const { error } = await authClient.signIn.email({ email, password });
          if (!error) return null;
          if (error.status === 0) return t.login.networkError;
          if (error.status === 429) return t.login.tooManyAttempts;
          return t.login.invalidCredentials;
        }}
      />
    </main>
  );
}
